/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateDeliveryAreaRequest,
  GetDeliveryAreas200ResponseInner,
  GetStorefrontCheckoutConfig200Response,
  GetStorefrontConfig200Response,
  GetStorefrontConfig200ResponseConfig,
  GetStorefrontReminders200ResponseInner,
  GetStorefrontScripts200ResponseInner,
  UpdateDeliveryAreaRequest,
  UpdateStorefrontCheckoutConfigRequest,
  UpdateStorefrontRemindersRequestInner,
  UpdateStorefrontScriptsRequestInner,
} from '../models/index';
import {
    CreateDeliveryAreaRequestFromJSON,
    CreateDeliveryAreaRequestToJSON,
    GetDeliveryAreas200ResponseInnerFromJSON,
    GetDeliveryAreas200ResponseInnerToJSON,
    GetStorefrontCheckoutConfig200ResponseFromJSON,
    GetStorefrontCheckoutConfig200ResponseToJSON,
    GetStorefrontConfig200ResponseFromJSON,
    GetStorefrontConfig200ResponseToJSON,
    GetStorefrontConfig200ResponseConfigFromJSON,
    GetStorefrontConfig200ResponseConfigToJSON,
    GetStorefrontReminders200ResponseInnerFromJSON,
    GetStorefrontReminders200ResponseInnerToJSON,
    GetStorefrontScripts200ResponseInnerFromJSON,
    GetStorefrontScripts200ResponseInnerToJSON,
    UpdateDeliveryAreaRequestFromJSON,
    UpdateDeliveryAreaRequestToJSON,
    UpdateStorefrontCheckoutConfigRequestFromJSON,
    UpdateStorefrontCheckoutConfigRequestToJSON,
    UpdateStorefrontRemindersRequestInnerFromJSON,
    UpdateStorefrontRemindersRequestInnerToJSON,
    UpdateStorefrontScriptsRequestInnerFromJSON,
    UpdateStorefrontScriptsRequestInnerToJSON,
} from '../models/index';

export interface CreateDeliveryAreaOperationRequest {
    createDeliveryAreaRequest: CreateDeliveryAreaRequest;
}

export interface DeleteDeliveryAreaRequest {
    areaId: string;
}

export interface UpdateDeliveryAreaOperationRequest {
    areaId: string;
    updateDeliveryAreaRequest?: UpdateDeliveryAreaRequest;
}

export interface UpdateStorefrontCheckoutConfigOperationRequest {
    updateStorefrontCheckoutConfigRequest: UpdateStorefrontCheckoutConfigRequest;
}

export interface UpdateStorefrontConfigRequest {
    getStorefrontConfig200ResponseConfig: GetStorefrontConfig200ResponseConfig;
}

export interface UpdateStorefrontRemindersRequest {
    updateStorefrontRemindersRequestInner?: Array<UpdateStorefrontRemindersRequestInner>;
}

export interface UpdateStorefrontScriptsRequest {
    updateStorefrontScriptsRequestInner?: Array<UpdateStorefrontScriptsRequestInner>;
}

/**
 * 
 */
export class StorefrontApi extends runtime.BaseAPI {

    /**
     */
    async createDeliveryAreaRaw(requestParameters: CreateDeliveryAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['createDeliveryAreaRequest'] == null) {
            throw new runtime.RequiredError(
                'createDeliveryAreaRequest',
                'Required parameter "createDeliveryAreaRequest" was null or undefined when calling createDeliveryArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/storefront/areas`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDeliveryAreaRequestToJSON(requestParameters['createDeliveryAreaRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async createDeliveryArea(requestParameters: CreateDeliveryAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createDeliveryAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteDeliveryAreaRaw(requestParameters: DeleteDeliveryAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['areaId'] == null) {
            throw new runtime.RequiredError(
                'areaId',
                'Required parameter "areaId" was null or undefined when calling deleteDeliveryArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/storefront/areas/{areaId}`.replace(`{${"areaId"}}`, encodeURIComponent(String(requestParameters['areaId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDeliveryArea(requestParameters: DeleteDeliveryAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDeliveryAreaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getDeliveryAreasRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetDeliveryAreas200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/storefront/areas`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetDeliveryAreas200ResponseInnerFromJSON));
    }

    /**
     */
    async getDeliveryAreas(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetDeliveryAreas200ResponseInner>> {
        const response = await this.getDeliveryAreasRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getStorefrontCheckoutConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStorefrontCheckoutConfig200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/storefront/checkout`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStorefrontCheckoutConfig200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getStorefrontCheckoutConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStorefrontCheckoutConfig200Response> {
        const response = await this.getStorefrontCheckoutConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getStorefrontConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStorefrontConfig200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/storefront/config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStorefrontConfig200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getStorefrontConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStorefrontConfig200Response> {
        const response = await this.getStorefrontConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getStorefrontRemindersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetStorefrontReminders200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/storefront/reminders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStorefrontReminders200ResponseInnerFromJSON));
    }

    /**
     */
    async getStorefrontReminders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetStorefrontReminders200ResponseInner>> {
        const response = await this.getStorefrontRemindersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getStorefrontScriptsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetStorefrontScripts200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/storefront/scripts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStorefrontScripts200ResponseInnerFromJSON));
    }

    /**
     */
    async getStorefrontScripts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetStorefrontScripts200ResponseInner>> {
        const response = await this.getStorefrontScriptsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateDeliveryAreaRaw(requestParameters: UpdateDeliveryAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['areaId'] == null) {
            throw new runtime.RequiredError(
                'areaId',
                'Required parameter "areaId" was null or undefined when calling updateDeliveryArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/storefront/areas/{areaId}`.replace(`{${"areaId"}}`, encodeURIComponent(String(requestParameters['areaId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDeliveryAreaRequestToJSON(requestParameters['updateDeliveryAreaRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateDeliveryArea(requestParameters: UpdateDeliveryAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDeliveryAreaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateStorefrontCheckoutConfigRaw(requestParameters: UpdateStorefrontCheckoutConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateStorefrontCheckoutConfigRequest'] == null) {
            throw new runtime.RequiredError(
                'updateStorefrontCheckoutConfigRequest',
                'Required parameter "updateStorefrontCheckoutConfigRequest" was null or undefined when calling updateStorefrontCheckoutConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/storefront/checkout`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateStorefrontCheckoutConfigRequestToJSON(requestParameters['updateStorefrontCheckoutConfigRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateStorefrontCheckoutConfig(requestParameters: UpdateStorefrontCheckoutConfigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateStorefrontCheckoutConfigRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateStorefrontConfigRaw(requestParameters: UpdateStorefrontConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getStorefrontConfig200ResponseConfig'] == null) {
            throw new runtime.RequiredError(
                'getStorefrontConfig200ResponseConfig',
                'Required parameter "getStorefrontConfig200ResponseConfig" was null or undefined when calling updateStorefrontConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/storefront/config`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GetStorefrontConfig200ResponseConfigToJSON(requestParameters['getStorefrontConfig200ResponseConfig']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateStorefrontConfig(requestParameters: UpdateStorefrontConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateStorefrontConfigRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateStorefrontRemindersRaw(requestParameters: UpdateStorefrontRemindersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/storefront/reminders`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateStorefrontRemindersRequestInner']!.map(UpdateStorefrontRemindersRequestInnerToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateStorefrontReminders(requestParameters: UpdateStorefrontRemindersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateStorefrontRemindersRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateStorefrontScriptsRaw(requestParameters: UpdateStorefrontScriptsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/storefront/scripts`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateStorefrontScriptsRequestInner']!.map(UpdateStorefrontScriptsRequestInnerToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateStorefrontScripts(requestParameters: UpdateStorefrontScriptsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateStorefrontScriptsRaw(requestParameters, initOverrides);
    }

}
